import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {OrgUnitHeader} from '../organization/org-unit-header';
import {Organization} from '../organization/organization';
import {GoogleService} from './google-service';
import {BrandID} from '../enums/brand-id';

@Service()
export class OrganizationService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public search(term: string): Observable<OrgUnitHeader[]> {
    let url = this.urlBase + 'organizations/search/' + term;
    return this.http.get<OrgUnitHeader[]>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  public getOrganization(id: string): Observable<Organization> {
    let url = this.urlBase + 'organizations/' + id;
    return this.http.get<Organization>(url, {headers: this.getRequestHeaders()});
  }

  public save(organization: Organization, brandID: BrandID): Observable<Organization> {
    let url = this.urlBase + 'organizations/save/' + brandID;
    let body = JSON.stringify(organization);
    return this.http.post<Organization>(url, body, {headers: this.getPostHeaders()});
  }

  isSiblingOrg(organization: Organization): boolean {
    return (organization.parentOrg && organization.parentOrg.length > 0) || false;
  }

  deactivate(organization: Organization, brandID: BrandID): Observable<string> {
    const url = this.urlBase + 'organizations/deactivate/' + brandID;
    const body = JSON.stringify(organization);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

}
